import { render, staticRenderFns } from "./MXFilter.vue?vue&type=template&id=1d80b2d7&scoped=true"
import script from "./MXFilter.vue?vue&type=script&lang=js"
export * from "./MXFilter.vue?vue&type=script&lang=js"
import "./MXFilter.vue?vue&type=style&index=0&id=1d80b2d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d80b2d7",
  null
  
)

export default component.exports